<template>
  <v-flex xs12 px-3 style="padding-top: 10px !important; width: 100vw;" class="repackagingContainer">
    <v-flex xs12>
      <v-btn @click="gotoFrontPage" style="width: 80px;" class="breadCrumb">
        <v-icon>home</v-icon>
      </v-btn>
      <v-btn @click="startRepackaging" class="breadCrumb">
        Repackaging
      </v-btn>
      <div style="height: 10px;"></div>
    </v-flex>
    <v-flex style="width: 50%; position: absolute; top: 50%; left: 50%; transform: translateY(-50%) translateX(-50%);" v-show="!showPalletDialog && !showChoosePalletDialog">
      <v-btn @click="openRepackagePalletDialog" style="width: 100%; height: 30vh !important; font-size: 36pt !important; margin-bottom: 2vh !important;">Repack pallet</v-btn>
    </v-flex>
    <v-dialog v-model="showPalletDialog" v-if="false" width="70vh" class="palletDialog" attach=".repackagingContainer" persistent>
      <div v-if="errorMessage" style="padding: 12px 25px; color: red; text-align: center; font-weight: bold; font-size: 2.25vh;">
        {{ errorMessage }}
      </div>
      <table class="numberPad" style="width: 100%;">
        <tr>
          <td colspan="3"><div class="numberPadValue">{{ currentPalletNumber }}</div></td>
          <td rowspan="4"><div :class="'repackagePalletBtn' + (!saveButtonEnabled ? ' disabled' : '')" @click="tryRepackagePallet()"><v-icon>done</v-icon></div></td>
        </tr>
        <tr>
          <td><div class="numberBtn" @click="numberClick(1)">1</div></td>
          <td><div class="numberBtn" @click="numberClick(2)">2</div></td>
          <td><div class="numberBtn" @click="numberClick(3)">3</div></td>
        </tr>
        <tr>
          <td><div class="numberBtn" @click="numberClick(4)">4</div></td>
          <td><div class="numberBtn" @click="numberClick(5)">5</div></td>
          <td><div class="numberBtn" @click="numberClick(6)">6</div></td>
        </tr>
        <tr>
          <td><div class="numberBtn" @click="numberClick(7)">7</div></td>
          <td><div class="numberBtn" @click="numberClick(8)">8</div></td>
          <td><div class="numberBtn" @click="numberClick(9)">9</div></td>
        </tr>
        <tr>
          <td><div class="numberBtn" @click="clear()">Clr</div></td>
          <td><div class="numberBtn" @click="numberClick(0)">0</div></td>
          <td><div class="numberBtn" @click="backspace()"><v-icon style="color: #DDDDDD; font-size: 5vh;">keyboard_backspace</v-icon></div></td>
          <td><div class="cancelBtn" @click="cancel()">Cancel</div></td>
        </tr>
      </table>
    </v-dialog>
    <v-container fluid pa-2 v-if="showPalletDialog" style="position: absolute; top: 50%; transform: translateY(-50%)">
      <v-layout style="max-height: calc(100vh - 160px);">
        <v-flex xs12 md5 lg4 pa-3>
          <table class="numberPad" style="width: 100%;">
            <tr>
              <td colspan="3"><div class="numberPadValue">{{ currentPalletNumber }}</div></td>
            </tr>
            <tr>
              <td><div class="numberBtn" @click="numberClick(1)">1</div></td>
              <td><div class="numberBtn" @click="numberClick(2)">2</div></td>
              <td><div class="numberBtn" @click="numberClick(3)">3</div></td>
            </tr>
            <tr>
              <td><div class="numberBtn" @click="numberClick(4)">4</div></td>
              <td><div class="numberBtn" @click="numberClick(5)">5</div></td>
              <td><div class="numberBtn" @click="numberClick(6)">6</div></td>
            </tr>
            <tr>
              <td><div class="numberBtn" @click="numberClick(7)">7</div></td>
              <td><div class="numberBtn" @click="numberClick(8)">8</div></td>
              <td><div class="numberBtn" @click="numberClick(9)">9</div></td>
            </tr>
            <tr>
              <td><div class="numberBtn" @click="clear()">Clr</div></td>
              <td><div class="numberBtn" @click="numberClick(0)">0</div></td>
              <td><div class="numberBtn" @click="backspace()"><v-icon style="color: #DDDDDD; font-size: 5vh;">keyboard_backspace</v-icon></div></td>
            </tr>
            <tr>
              <td colspan="3"><div :class="'saveBtn' + (!saveButtonEnabled ? ' disabled' : '')" @click="tryRepackagePallet">Repack pallet</div></td>
            </tr>
          </table>
        </v-flex>
        <v-flex xs12 md7 lg8 pa-3>
          <PanelColumn title="Repackaging history" margin-bottom="0"/>
          <v-data-table :headers="historyHeaders" :items="historyItems" hide-actions class="historyTable" v-if="historyItems.length > 0">
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-left">{{ formatDatetime(props.item.timestamp) }}</td>
                <td class="text-xs-left">{{ props.item.pallet.number }}</td>
                <td class="text-xs-left"><div v-html="categories(props.item.pallet)"></div></td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="showChoosePalletDialog" attach=".repackagingContainer" width="unset" content-class="choosePalletDialog" persistent hide-overlay>
      <v-card pa-5>
        <v-card-title class="headline">Choose pallet to repackage</v-card-title>
        <v-card-text style="padding-bottom: 0;">
          <div style="padding-bottom: 0;">There is more than one pallet with this number, please choose one.</div>
          <div v-if="errorMessage" style="padding: 8px; border: 1px solid red; border-radius: 3px; color: red; text-align: center; font-weight: bold;">
            {{ errorMessage }}
          </div>
          <div style="height: 10px;"></div>
          <v-radio-group v-model="chosenPallet">
            <table class="choosePallet">
              <tr>
                <th></th>
                <th class="text-xs-left" style="width: 100px;">Pallet no.</th>
                <th class="text-xs-left" style="width: 140px;">Ext. pallet no.</th>
                <th class="text-xs-left" style="width: 120px;">State</th>
                <th class="text-xs-left">Category</th>
                <th class="text-xs-right" style="width: 110px;">Amount</th>
              </tr>
              <tr v-for="pallet in this.palletsByNumber" v-bind:key="pallet.id">
                <td>
                  <v-radio :value="pallet" color="#004d40"></v-radio>
                </td>
                <td class="text-xs-left">{{ pallet.number }}</td>
                <td class="text-xs-left">{{ pallet.externalNumber }}</td>
                <td class="text-xs-left">{{ pallet.stateLabel }}</td>
                <td class="text-xs-left"><div v-html="pallet.categories"></div></td>
                <td class="text-xs-right" style="width: 60px;"><div v-html="pallet.amounts"></div></td>
              </tr>
            </table>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="repackageChosenPallet" class="bw-4 choosePalletButton" :disabled="chosenPallet === null">Repack pallet</v-btn>
          <div style="width: 10px;"></div>
          <v-btn flat @click="showChoosePalletDialog = false" class="bw-4 choosePalletButton">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ErrorDialog ref="errorDialog"/>
  </v-flex>
</template>

<script>
import Panel from '../components/Panel'
import LoaderPallet from '../components/LoaderPallet'
import PanelColumn from '../components/PanelColumn'
import ErrorDialog from '../components/ErrorDialog'
import axios from 'axios'
import DateUtil from '@/assets/javascript/dateutil'

export default {
  name: 'TodoRepackaging',
  components: { Panel, LoaderPallet, PanelColumn, ErrorDialog },
  data () {
    return {
      showPalletDialog: false,
      currentPallet: null,
      historyItems: [],
      historyHeaders: [
        { text: 'Timestamp', value: 'timestamp', sortable: false },
        { text: 'Pallet no.', value: 'number', sortable: false },
        { text: 'Categories', sortable: false }
      ],
      currentPalletNumber: '',
      showChoosePalletDialog: false,
      palletsByNumber: [],
      chosenPallet: null,
      errorMessage: ''
    }
  },
  created: function () {
    this.startRepackaging()
  },
  computed: {
    saveButtonEnabled: function () {
      return this.palletNumberIsCorrectLength
    },
    palletNumberIsCorrectLength: function () {
      return this.currentPalletNumber !== null && ('' + this.currentPalletNumber).length >= 1 && ('' + this.currentPalletNumber).length <= 6
    }
  },
  methods: {
    gotoFrontPage: function () {
      this.$parent.$parent.gotoHome()
    },
    startRepackaging: function () {
      this.currentPickupAddress = null
      this.currentType = null
      this.currentShipment = null
    },
    openRepackagePalletDialog: function () {
      this.currentPalletNumber = ''
      this.errorMessage = null
      this.showPalletDialog = true
    },
    formatDatetime (date) {
      return DateUtil.datetimeToString(date)
    },
    categories: function (pallet) {
      let categories = ''
      if (pallet.items) {
        let items = pallet.items
        for (let item of items) {
          if (categories.length > 0) {
            categories += '<br/>'
          }
          categories += (item.category ? item.category.label : item.categoryName)
          categories += ', ' + item.amount + 'pcs.'
        }
      }
      return categories
    },
    numberClick: function (number) {
      let val = '' + this.currentPalletNumber
      if (val.length < 6) {
        let value = this.currentPalletNumber
        if (value === null) {
          value = ''
        }
        value = value + '' + number
        this.currentPalletNumber = value
      }
    },
    clear: function () {
      this.currentPalletNumber = ''
    },
    backspace: function () {
      let val = '' + this.currentPalletNumber
      if (val.length > 1) {
        this.currentPalletNumber = val.substring(0, val.length - 1)
      } else {
        this.clear()
      }
    },
    cancel: function () {
      this.showPalletDialog = false
    },
    tryRepackagePallet: function () {
      if (this.palletNumberIsCorrectLength) {
        this.chosenPallet = null
        axios.get('/backend/rest/pallet/summary/by_number/' + this.currentPalletNumber)
          .then(response => {
            this.palletsByNumber = response.data

            if (this.palletsByNumber && this.palletsByNumber.length === 0) {
              this.$refs.errorDialog.errorMessage = 'Pallet number is not correct'
              this.$refs.errorDialog.errorDialog = true
            } else if (this.palletsByNumber && this.palletsByNumber.length === 1) {
              this.repackagePallet(this.palletsByNumber[0])
            } else {
              // Let the user decide which pallet to load
              this.showPalletDialog = false
              this.showChoosePalletDialog = true
            }
          })
      }
    },
    repackageChosenPallet: function () {
      this.repackagePallet(this.chosenPallet)
    },
    repackagePallet: function (pallet) {
      let command = {
        command: 'REPACK',
        palletId: pallet.id,
        palletNumber: pallet.palletNumber,
        timestamp: new Date()
      }
      axios.post('/backend/rest/command/repackaging', command)
        .then(response => {
          if (response.data && response.data.pallet) {
            let pallet = response.data.pallet
            this.currentPalletNumber = null
            let history = {
              timestamp: command.timestamp,
              pallet: pallet
            }
            this.historyItems.splice(0, 0, history)
            this.showChoosePalletDialog = false
            this.showPalletDialog = true
          }
        })
        .catch(error => {
          let errorMessage = 'Failed to repack pallet'
          if (error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message
          }
          console.log(error.response.data.message)
          if (this.showPalletDialog || this.showChoosePalletDialog) {
            this.errorMessage = errorMessage
          } else {
            this.$refs.errorDialog.errorTitle = error.response.data.title
            this.$refs.errorDialog.errorMessage = errorMessage
            this.$refs.errorDialog.errorDialog = true
          }
        })
    }
  }
}
</script>

<style scoped>
  button {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .breadCrumb {
    height: 30px !important;
    padding: 0 20px !important;
    margin-right: 6px !important;
    border-top-left-radius: 5px !important;
    border-bottom-left-radius: 5px !important;
    border-top-right-radius: 5px !important;
    border-bottom-right-radius: 15px !important;
  }
  .v-btn {
    border-radius: 12px;
  }
  .palletDialog {
    box-shadow: none;
    background-color: white;
  }
  .numberPad {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    margin-left: auto;
    margin-right: auto;
    border-radius: 10px;
  }
  .numberPad tr {
    border: none;
  }
  .numberPad tr td {
    border: none;
    padding: 0.3vh;
    text-align: right;
    width: 33%;
  }
  .numberBtn {
    width: 100%;
    height: 10vh;
    text-align: center;
    vertical-align: center;
    line-height: 10vh;
    font-size: 5vh;
    background-color: #003d30;
    border-radius: 10px;
    margin: 0;
    cursor: pointer;
    color: #DDDDDD;
    user-select: none;
    transition: .2s cubic-bezier(.25,.8,.5,1);
  }
  .saveBtn {
    width: 100%;
    height: 10vh;
    text-align: center;
    vertical-align: center;
    line-height: 10vh;
    font-size: 5vh;
    background-color: #003d30;
    border-radius: 10px;
    margin: 0;
    cursor: pointer;
    color: #DDDDDD;
    user-select: none;
    transition: .2s cubic-bezier(.25,.8,.5,1);
  }
  .saveBtn .v-icon {
    font-size: 10vh;
    color: rgb(221, 221, 221);
  }
  .cancelBtn {
    width: 100%;
    height: 10vh;
    text-align: center;
    vertical-align: center;
    line-height: 10vh;
    font-size: 4vh;
    background-color: #003d30;
    border-radius: 10px;
    margin: 0;
    cursor: pointer;
    color: #DDDDDD;
    user-select: none;
    transition: .2s cubic-bezier(.25,.8,.5,1);
  }
  .numberBtn:hover {
    background-color: rgba(0, 62, 48, 0.87);
    transition: .2s cubic-bezier(.25,.8,.5,1);
  }
  .numberPadValue {
    border: 1px solid #004d40;
    border-radius: 10px;
    height: 10vh;
    width: 100%;
    cursor: pointer;
    font-size: 7vh;
    line-height: 10vh;
    text-align: right;
    padding: 0 10px;
    color: rgba(0, 0, 0, 0.87);
  }
  .historyHeader {
    margin-bottom: 0 !important;
  }
  .historyTable {
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
  }
  table.choosePallet {
    width: 100%;
    border-collapse: collapse;
  }
  table.choosePallet th {
    border-bottom: 1px solid #808080;
    padding: 1px 5px 1px 5px;
  }
  table.choosePallet td {
    border-bottom: 1px solid #CCCCCC;
    padding: 5px;
    vertical-align: top;
    line-height: 20px;
  }
  .palletDialog {
    box-shadow: none;
    background-color: white;
  }
  .numberPad {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    margin-left: auto;
    margin-right: auto;
    border-radius: 10px;
  }
  .numberPad tr {
    border: none;
  }
  .numberPad tr td {
    border: none;
    padding: 0.3vh;
    text-align: right;
    width: 33%;
  }
  .numberBtn {
    width: 100%;
    height: 10vh;
    text-align: center;
    vertical-align: center;
    line-height: 10vh;
    font-size: 5vh;
    background-color: #003d30;
    border-radius: 10px;
    margin: 0;
    cursor: pointer;
    color: #DDDDDD;
    user-select: none;
    transition: .2s cubic-bezier(.25,.8,.5,1);
  }
  .repackagePalletBtn {
    width: 20vh;
    height: 41.8vh;
    text-align: center;
    vertical-align: center;
    padding-top: 15vh;
    line-height: 10vh;
    font-size: 5vh;
    background-color: #003d30;
    border-radius: 10px;
    margin: 0;
    cursor: pointer;
    color: #DDDDDD;
    user-select: none;
    transition: .2s cubic-bezier(.25,.8,.5,1);
  }
  .repackagePalletBtn .v-icon {
    font-size: 10vh;
    color: rgb(221, 221, 221);
  }
  .disabled {
    background-color: #DDDDDD;
    cursor: default;
    color: #AAAAAA;
  }
  .disabled .v-icon {
    color: #AAAAAA;
  }
</style>



// WEBPACK FOOTER //
// src/components/TodoRepackaging.vue